<template>
  <loading :background-color="isInDarkMode ? '#000' : '#FFF'" :color="isInDarkMode ? '#FFF' : '#000'" loader="bars" :active.sync="dialog.modal_loader" :opacity="0.88" style="z-index: 99998">
    <span slot="after">
      <br />
      {{ dialog.options && dialog.options.message ? dialog.options.message : msg }}
    </span>

    <!-- <div class="rotatinglogocontainer" style="position: absolute; width: 100%; height: 100%">
      <div class="rotatinglogobackground" style="position: absolute; width: 100%; height: 100%"></div> -->
    <img :src="Logo" width="100px" height="100px" class="rotatinglogo" />
    <!-- </div> -->
  </loading>

  <!-- <div id="loader-wrapper">
    <v-card class="loader-card-back">
    <v-row class="loader-card">
      <v-col class="subtitle-1 text-center white--text" cols="12">
        <span class>{{ msg }}</span>
      </v-col>
      <v-col cols="12">
        <v-progress-linear v-if="linear" style="background-color: rgb(18, 77, 104);" indeterminate color="light-blue" height="10" striped></v-progress-linear>
        <v-row v-else justify="center">
          <v-progress-circular :size="70" :width="7" color="light-blue" indeterminate></v-progress-circular>
        </v-row>
      </v-col>
    </v-row>
    </v-card>
  </div>-->
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { TR } from "../../main";

export default {
  components: {
    Loading,
  },
  props: {},
  data() {
    return {
      Logo: require("@/assets/img/main/darkLogo.png"),
      msg: {
        type: String,
        default: TR.LoadingView_LoadingInfo,
      },
    };
  },
  computed: {},
  methods: {},
  created() {
    if (this.dialog.options && this.dialog.options.message) {
      this.msg = this.dialog.options.message;
    }
  },
  mounted() {},
};
</script>

<style>
.vld-icon {
  text-align: center;
}

.rotatinglogobackground {
  background-color: white;
  -webkit-filter: blur(5px);
  -moz-filter: blur(5px);
  -o-filter: blur(5px);
  -ms-filter: blur(5px);
  filter: blur(5px);
  opacity: 0.93;
}
.rotatinglogocontainer .rotatinglogo {
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  text-align: center;
  z-index: 1;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
}

.rotatinglogo {
  position: relative;
  display: inline-block;
  z-index: 2147483647;
  -moz-animation: rotatinglogo 1s linear infinite;
  -webkit-animation: rotatinglogo 1s linear infinite;
  animation: rotatinglogo 1s linear infinite;
}

@-moz-keyframes rotatinglogo {
  0% {
    -moz-transform: rotate(0deg);
  }
  50% {
    -moz-transform: rotate(90deg) scale(0.7);
  }
  100% {
    -moz-transform: rotate(360deg);
  }
}
@-webkit-keyframes rotatinglogo {
  0% {
    -webkit-transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(90deg) scale(0.7);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes rotatinglogo {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(90deg) scale(0.7);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* #loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}

.loader-card-back {
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
}
.loader-card {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9;
} */
</style>